import { useEffect } from "react";
import { X } from "lucide-react";
import { Button, IconButton } from "./Button";

export function Modal({ open, onClose, title, description, children, width = "md", footer }) {
  useEffect(() => {
    if (!open) return undefined;
    const handler = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.body.classList.add("has-overlay");
    window.addEventListener("keydown", handler);
    return () => {
      document.body.classList.remove("has-overlay");
      window.removeEventListener("keydown", handler);
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="overlay" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose?.()}>
      <section className={`modal modal--${width}`} role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <header>
          <div>
            <h2 id="modal-title">{title}</h2>
            {description ? <p>{description}</p> : null}
          </div>
          <IconButton label="关闭" icon={X} onClick={onClose} />
        </header>
        <div className="modal__body">{children}</div>
        {footer ? <footer>{footer}</footer> : null}
      </section>
    </div>
  );
}

export function Drawer({ open, onClose, title, description, children, width = "md", footer }) {
  return (
    <Modal open={open} onClose={onClose} title={title} description={description} width={width} footer={footer}>
      {children}
    </Modal>
  );
}

export function ConfirmDialog({ open, onClose, onConfirm, title, description, confirmLabel = "确认", danger = false, loading = false }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      width="sm"
      footer={(
        <>
          <Button onClick={onClose}>取消</Button>
          <Button variant={danger ? "danger" : "primary"} loading={loading} onClick={onConfirm}>{confirmLabel}</Button>
        </>
      )}
    />
  );
}
